import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=523b347f&scoped=true"
import script from "./MyPage.vue?vue&type=script&lang=ts"
export * from "./MyPage.vue?vue&type=script&lang=ts"
import style0 from "./MyPage.vue?vue&type=style&index=0&id=523b347f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b347f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523b347f')) {
      api.createRecord('523b347f', component.options)
    } else {
      api.reload('523b347f', component.options)
    }
    module.hot.accept("./MyPage.vue?vue&type=template&id=523b347f&scoped=true", function () {
      api.rerender('523b347f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/MyPage.vue"
export default component.exports